<template>
  <div class="scroll-vertical full-height big-spacer related-binaries">
    <div v-for="binary in binaries" :key="binary.sha1hex" class="spacer">
      <alert-log-binary :binary="binary" :related="related"></alert-log-binary>
    </div>
  </div>
</template>

<script>
import AlertLogBinary from '@/components/alertlogs/AlertLogBinary.vue';

export default {
  name: 'AlertRelatedFiles',
  components: {
    AlertLogBinary,
  },
  props: {
    binaries: {
      type: Array,
      required: true,
    },
    related: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.spacer {
  margin-bottom: 1rem;
}

.big-spacer {
  padding-bottom: 8rem;
}

.full-height {
  height: 100%;
}
</style>
